import { Label } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { API_ENDPOINT } from "../../../constants/appConstant";
import { useNetwork } from "../../../hooks/useNetwork";
import {
  CheckboxOptionType,
  DropdownOptionType,
  MasterDataType,
} from "../../../types";
import { MultiDropDownController } from "../../controllers";
import { ActionButtonContainer } from "../common/ActionButtonContainer";
import { Heading } from "../common/Heading";
import { LinkedInConsent } from "../common/Linkedin/LinkedinConsent";
import { LinkedinURL } from "../common/Linkedin/LinkedinURL";
import { JobPreferencesApopUIProps } from "./JobPreferences.types";

export const JobPreferencesApopUI = ({
  prefilledData,
  closeApop,
  onSubmit,
  isSubmitAPILoading,
}: JobPreferencesApopUIProps) => {
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm();

  const [desingationData, setDesingationData] = useState<
    CheckboxOptionType[] | null
  >(null);
  const [showLinkedinURL, setShowLinkedinURL] = useState(true);
  // const [isAutoUpdateChecked, setIsAutoUpdateChecked] = useState(false);
  // const [showLinkedinConsent, setShowLinkedinConsent] = useState(true);

  const [isExperienced, setIsExperienced] = useState(
    prefilledData?.experienceLevel === "EXPERIENCED",
  );
  const [skillsData, setSkillsData] = useState<CheckboxOptionType[] | null>(
    null,
  );
  const [isDropdownOptionLoading, setIsDropdownOptionLoading] = useState(false);

  const { fetchData: fetchAPI } = useNetwork();

  const prefillDataHelper = (prefillData: any) => {
    const { experienceLevel, jobPreferencesPrefill, linkedInResponse } =
      prefillData;

    if (experienceLevel && experienceLevel === "EXPERIENCED") {
      setIsExperienced(true);
    } else {
      setIsExperienced(false);
    }

    if (jobPreferencesPrefill) {
      const { skills, roles } = jobPreferencesPrefill;
      if (skills) {
        const updatedSkills = skills.map((skill: any) => {
          return {
            value: skill.skill.value,
            id: skill.skill.id,
            text: skill.skill.text,
          };
        });
        setValue("keySkills", updatedSkills);
      }
      if (roles) {
        const updatedRoles = roles.map((role: any) => {
          return {
            value: role.value,
            id: role.id,
            text: role.text,
          };
        });
        setValue("jobTitle", updatedRoles);
      }
    }

    if (linkedInResponse) {
      const { linkedInConsent, url } = linkedInResponse;

      if (url) {
        setValue("linkedin", url);
        setShowLinkedinURL(false);
      } else {
        setShowLinkedinURL(true);
      }
      // if (linkedInConsent === false || linkedInConsent === true) {
      //   setValue("isToggled", linkedInConsent);
      //   setShowLinkedinConsent(false);
      // } else {
      //   setShowLinkedinConsent(true);
      //   setValue("isToggled", true);
      //   setIsAutoUpdateChecked(true);
      // }
    } else {
      setShowLinkedinURL(true);
      // setShowLinkedinConsent(true);
      // setValue("isToggled", true);
      // setIsAutoUpdateChecked(true);
    }
  };

  useEffect(() => {
    if (prefilledData) {
      prefillDataHelper(prefilledData);
    }
  }, [prefilledData]);

  const skillsDropdownOptionsData = async (skill: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?appName=srp-ui&type=SKILL&limit=10&name=${skill}`,
      "GET",
    );

    const masterSkillsData = (res.data as any)?.data as MasterDataType[];

    const updatedSkillsData =
      masterSkillsData && masterSkillsData.length > 0
        ? masterSkillsData.map((skill) => {
            return {
              value: skill.name,
              id: skill.uuid,
              text: skill.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setSkillsData(updatedSkillsData);
  };

  const designationDropdownOptionsHandler = async (desingation: string) => {
    setIsDropdownOptionLoading(true);
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?appName=srp-ui&type=DESIGNATION&limit=10&name=${desingation}`,
      "GET",
    );

    const masterDesingationData = (res.data as any)?.data as MasterDataType[];

    const updatedDesingationData =
      masterDesingationData && masterDesingationData.length > 0
        ? masterDesingationData.map((desingation) => {
            return {
              value: desingation.name,
              id: desingation.uuid,
              text: desingation.name,
            };
          })
        : null;

    setIsDropdownOptionLoading(false);
    setDesingationData(updatedDesingationData);
  };

  const onSubmitHandler = async (data: any) => {
    onSubmit(data);
  };

  return (
    <>
      <Heading
        headingText="Job Preferences"
        isMobile={window.innerWidth < 768}
        onCloseBtnClickHandler={() => {
          closeApop();
        }}
      />

      <form
        className="l1-relative l1-mb-16 l1-mt-10 l1-flex l1-w-full l1-flex-col l1-gap-4 md:l1-mb-12 md:l1-mt-9"
        id="jobPreferencesDetailsForm"
        onSubmit={handleSubmit(onSubmitHandler)}
        noValidate
      >
        <p className="l1-text-xs l1-text-gray-400">
          Helps to find better matching jobs
        </p>

        <div className="l1-flex l1-flex-col l1-gap-4">
          {showLinkedinURL ? (
            <LinkedinURL
              register={register}
              setValue={setValue}
              errors={errors}
              setError={setError}
              clearError={() => clearErrors("linkedin")}
            />
          ) : null}
          {/* <div className="l1-flex l1-flex-col l1-gap-3">
            <Label
              labelText="Share your LinkedIn Profile URL"
              isRequired={false}
              className="l1-text-sm"
            >
              <Input
                id="linkedin"
                placeholder="www.linkedin.com/in/your-id"
                {...register("linkedin", {
                  pattern: {
                    value: LINKEDIN_REGEX,
                    message: "Invalid linkedin url",
                  },
                  onBlur: (e: React.ChangeEvent<HTMLInputElement>) =>
                    handleBlur(e),
                })}
                errorText={errors.linkedin ? "Enter a valid LinkedIn URL" : ""}
              />
            </Label>
            <div className="l1-flex l1-flex-row l1-items-center l1-justify-between">
              <p className="l1-text-xs">
                Activate auto-update for your profile.{" "}
                <button
                  className="l1-text-[#0d99ff] hover:l1-underline"
                  type="button"
                  onClick={() => setShowKnowMoreModal(true)}
                >
                  Know More
                </button>
              </p>

              <Controller
                name="isToggled"
                control={control}
                render={() => {
                  return (
                    <Toggle
                      // {...field}
                      id="isToggled"
                      size="small"
                      checked={isAutoUpdateChecked}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setValue("isToggled", e.target.checked);
                        setIsAutoUpdateChecked(e.target.checked);
                      }}
                      disabled={isToggleDisabled}
                    />
                  );
                }}
              />
            </div>
          </div> */}

          <Label
            labelText="Key Skills"
            isRequired={true}
            className="!l1-text-sm"
          >
            <MultiDropDownController
              name="keySkills"
              control={control}
              isRequired={true}
              isSearchable={true}
              maxSelect={50}
              options={skillsData ?? []}
              onSelect={(selected: DropdownOptionType) => {
                clearErrors("keySkills");
                setValue("keySkills", selected);
              }}
              isLoading={isDropdownOptionLoading}
              onChangeHandler={(inputText: string) => {
                skillsDropdownOptionsData(inputText);
              }}
              placeholder={
                getValues("keySkills")
                  ? "Maximum 50 skills can be selected"
                  : "Expert to beginner- flaunt them all!"
              }
              isDisabled={false}
              errorMessage={errors.keySkills ? "This field is required" : ""}
            />
          </Label>

          {/* {!isExperienced && ( */}
          <Label
            labelText="Preferred Job Title"
            isRequired="true"
            className="!l1-text-sm"
          >
            <MultiDropDownController
              name="jobTitle"
              control={control}
              isRequired={true}
              isSearchable={true}
              maxSelect={5}
              options={desingationData ?? []}
              isLoading={isDropdownOptionLoading}
              onSelect={(selected: DropdownOptionType) => {
                clearErrors("jobTitle");
                setValue("jobTitle", selected);
              }}
              onChangeHandler={(inputText: string) => {
                designationDropdownOptionsHandler(inputText);
              }}
              placeholder={
                getValues("jobTitle") && getValues("jobTitle").length >= 5
                  ? "Maximum 5 preferred job titles can be selected"
                  : "Enter or select your preferred job titles"
              }
              errorMessage={errors.jobTitle ? "This field is required" : ""}
              isDisabled={false}
            />
          </Label>
          {/* )} */}

          {/* {showLinkedinConsent ? (
            <LinkedInConsent
              checked={isAutoUpdateChecked}
              handleConsentToggle={(e: React.ChangeEvent<HTMLInputElement>) => {
                setValue("isToggled", e.target.checked);
                setIsAutoUpdateChecked(e.target.checked);
              }}
            />
          ) : null} */}
        </div>

        <ActionButtonContainer
          primaryBtnLabel="Save"
          isLoading={isSubmitAPILoading}
        />
      </form>
    </>
  );
};
